import axios from 'axios'
import { Loading } from 'element-ui';
import { message } from "./assets/js/resetMessage";
import router from './router'

let loading        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}


// 请求拦截  设置统一header
axios.interceptors.request.use(config => {
    if (localStorage.eleToken)
        config.headers.Token = localStorage.eleToken
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截  401 token过期处理
axios.interceptors.response.use(response => {
    // endLoading()
    // console.log(response.data)
    if (response.data.code == 401) {
        if (response.config.url == "http://120.78.89.173:8080/SysApi/api/user/info" || response.config.url == "/SysApi/api/user/info") {

        } else {
            message.error('未登录或者账号过期，请重新登录')
            // 清除token
            localStorage.removeItem('eleToken')
            sessionStorage.clear()
        }
        try {
            router.push('/')
        } catch (err) {

        }

        return;
    }
    if (response.data.code == 500) {
        message.error(response.data.msg)
    }
    return response

}, error => {
    // 错误提醒
    // endLoading()
    message.error(error.response.data)

    const { status } = error.response
    if (status == 401) {
        message.error('未登录或者账号过期，请重新登录')
        // 清除token
        localStorage.removeItem('eleToken')

        // // 页面跳转
        router.push('/')
    }

    if (status == 500) {
        message.error('系统繁忙')
    }

    return Promise.reject(error)
})

export default axios